import { useEffect } from "react";

const URL_UPDATE_DEBOUNCE_MS = 300;

/**
 * Synchronizes a query value with the URL's search parameter.
 * Updates are debounced to avoid excessive history operations.
 * Uses replaceState to update the URL without creating new history entries.
 *
 * @param queryValue - The current query value to sync with URL
 */
export function useUrlSync(queryValue: string) {
	useEffect(() => {
		if (typeof window === "undefined") return;

		const timer = setTimeout(() => {
			const url = new URL(window.location.href);
			const trimmedValue = queryValue.trim();

			if (trimmedValue) {
				url.searchParams.set("q", queryValue);
			} else {
				url.searchParams.delete("q");
			}

			if (url.href !== window.location.href) {
				window.history.replaceState(null, "", url);
			}
		}, URL_UPDATE_DEBOUNCE_MS);

		return () => clearTimeout(timer);
	}, [queryValue]);
}
